export const GSAT_CHAT_ROOM_NAME = '삼성 GSAT 시험논의'
